import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Flex, Text, Box } from 'rebass/styled-components';
import { TagItem } from './TagItem';
import { CheckBoxItem } from './CheckboxItem';

const types = { checkbox: CheckBoxItem, radio: CheckBoxItem, tag: TagItem };

export const MultiSelect = ({ options, onChange, type, multi, label, initialData, autoSelectRadio, variant }) => {
  const isMultiSelect = multi || type !== 'radio';
  const isMultiSelectInitial = isMultiSelect && initialData?.length ? initialData.map((item) => item.id) : [];
  const notMultiselectInitial =
    !isMultiSelect && (autoSelectRadio || Object.keys(initialData).length) ? [initialData.id || options[0].id] : [];

  const [selected, setSelected] = useState(new Set(isMultiSelect ? isMultiSelectInitial : notMultiselectInitial));

  const remove = (id) => {
    if (!isMultiSelect && selected.has(id)) {
      return;
    }
    const updatedEntries = new Set(Array.from(selected).filter((item) => item !== id));

    if (onChange) {
      const changedData = options.filter((option) => updatedEntries.has(option.id));
      onChange(isMultiSelect ? changedData : changedData[0]);
    }

    setSelected(updatedEntries);
  };

  const add = (id) => {
    if (isMultiSelect) {
      selected.add(id);
    } else {
      selected.clear();
      selected.add(id);
    }

    setSelected(new Set(selected));

    if (onChange) {
      const changedData = options.filter((option) => selected.has(option.id));
      onChange(isMultiSelect ? changedData : changedData[0]);
    }
  };

  const Component = types[type];

  return (
    <>
      {label && (
        <Box>
          <Text fontSize="18px" lineHeight="1.4" as="h4" mb="16px" fontWeight="500" color="text.main">
            {label}
          </Text>
        </Box>
      )}
      <Flex flexDirection={type === 'tag' ? 'row' : 'column'} mw="600px" flexWrap="wrap" sx={{ gap: '8px' }}>
        {options.map((option) => (
          <Component
            key={option.id}
            onAdd={() => add(option.id)}
            onRemove={() => remove(option.id)}
            selected={selected.has(option.id)}
            option={option}
            type={type}
            variant={variant}
          >
            {option.children}
          </Component>
        ))}
      </Flex>
    </>
  );
};

MultiSelect.defaultProps = {
  multi: false,
  label: '',
  initialData: [],
  autoSelectRadio: false,
  variant: 'default',
};

MultiSelect.propTypes = {
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['radio', 'checkbox', 'tag']).isRequired,
  multi: PropTypes.bool,
  label: PropTypes.string,
  initialData: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  autoSelectRadio: PropTypes.bool,
  variant: PropTypes.string,
};

export default MultiSelect;
